import { render, staticRenderFns } from "./UserBenefits.vue?vue&type=template&id=6c36504f"
import script from "./UserBenefits.js?vue&type=script&lang=js&external"
export * from "./UserBenefits.js?vue&type=script&lang=js&external"
import style0 from "./UserBenefits.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports